module.exports = __webpack_public_path__ + "static/media/WheatStage110.a31e5b91.PNG";